import { render } from "./EditableHeading.vue?vue&type=template&id=0eafb4ee"
import script from "./EditableHeading.vue?vue&type=script&lang=js"
export * from "./EditableHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__